import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,

  environment: process.env.REACT_APP_ENV,

  enabled: process.env.REACT_APP_ENV === "production",

  tracesSampleRate: 0.1,
});
